import React, { useCallback, useRef } from 'react';
import { Justify, List } from 'tea-component';
import CardCommon from '@op/components/CardCommon';
import DiscussionItem from '../DiscussionItem';
import EventOverview from '../EventOverview';
import PostContentPanel from '../PostContentPanel';
import { IDiscussionItem } from '../types';
import { useHotEventContext } from '../../../context';
import './index.scss';

interface DiscussionDetailProps {
  item: IDiscussionItem | null;
  filterParams: Record<string, any> | undefined;
  loading?: boolean;
}

/**
 * 右侧：选中项详情（含 Overview + 帖子内容）V2
 * - Content 区域：直接读取列表行字段（无需额外请求）
 * - Language 分布：由 EventOverview 内部 OverviewLanguages 组件管理
 * - 主贴/评论列表：feeds/comments（由 PostContentPanel 内部 hook 管理）
 * - 滚动加载：由 dbo-discussion-detail-body-cardCommon 上的 List 组件统一管理
 */
export default function DiscussionDetail({ item, filterParams, loading }: DiscussionDetailProps) {
  const { gameInfo, channelType } = useHotEventContext();

  // 存储当前活跃 Tab 的滚动加载处理器
  const scrollHandlerRef = useRef<() => void>(() => { });

  const handleScrollBottom = useCallback(() => {
    scrollHandlerRef.current?.();
  }, []);

  const handleScrollStateChange = useCallback(
    (state: { handleScrollBottom: () => void; loadingMore: boolean }) => {
      scrollHandlerRef.current = state.handleScrollBottom;
    },
    [],
  );

  return (
    <CardCommon className="dbo-discussion-detail" empty={!item} loading={loading} loadingHeight={600}>
      {item ? (
        <div className="dbo-discussion-detail-body">
          {/* 事件标题 + 情感 + 指标 */}
          <DiscussionItem item={item} />
          <CardCommon contentCard loadingHeight={500} >
            <List onScrollBottom={handleScrollBottom} className="dbo-discussion-detail-body-cardCommon">
              <div className="dbo-discussion-detail-list">
                {/* 第一部分：Overview（Summary | Language） */}
                <EventOverview
                  item={item}
                  filterParams={filterParams}
                />
                {/* 第二部分：帖子内容（Posts | Comments） */}
                <PostContentPanel
                  item={item}
                  gameInfo={gameInfo}
                  filterParams={filterParams}
                  channelType={channelType}
                  onScrollStateChange={handleScrollStateChange}
                />
              </div>
            </List>
          </CardCommon>
        </div>
      ) : null}
    </CardCommon>
  );
}
